
import { Component, Vue } from "vue-property-decorator"

@Component
export default class HeartButton extends Vue {
	onClick() {
		console.log("test")
		this.$emit("iconClicked")
	}
}
